<template>
    <div class="tx-history-wrap">
        <table class="ui-table">
            <thead v-if="list && list.length > 0">
                <tr>
                    <th style="max-width: none;">{{ $t('common.address') }}</th>
                    <th style="max-width: none;">{{ $t('multisig.role') }}</th>
                </tr>
            </thead>
            <template v-if="list && list.length > 0 && !isLoading">
                <tbody v-for="item in list" v-bind:key="`addressList_${item.address}_${item.role}`">
                    <tr>
                        <td><ui-address v-bind:address="addressbook[item.address].user_friendly" /></td>
                        <td>{{ $t(`multisig.roles.${item.role}`) }}</td>
                    </tr>
                </tbody>
            </template>
            <template v-else-if="list && list.length === 0 && !isLoading">
                <div class="tx-history-empty-panel">
                    {{ $t('multisig.addresslist_empty') }}
                </div>
            </template>
            <template v-else>
                <tbody v-for="i in 8" v-bind:key="`addressList_skeleton_${i}`">
                    <td v-pre>
                        <span class="tx-table-cell-skeleton" style="width: 100%;"></span>
                    </td>
                </tbody>
            </template>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        addressList: Object,
        addressbook: Object,
        isLoading: Boolean,
    },

    computed: {
        list() {
            const signers = this.addressList.signers.map(addr => ({
                address: addr,
                role: 'signer',
            }));
            const proposers = this.addressList.proposers.map(addr => ({
                address: addr,
                role: 'proposer',
            }));
            return [...signers, ...proposers];
        },
    },
};
</script>

<style lang="scss">

</style>
